import { axios } from '@Root/API'

export const edit = (id, payload) => {
	return axios.post(`engagement/${id}/student-registration`, payload)
}
